import SocialFollow from './SocialFollow';
export default SocialFollow;
//# sourceMappingURL=index.js.map